import { render, staticRenderFns } from "./ShotsTable.vue?vue&type=template&id=0ad53ae5"
import script from "./ShotsTable.vue?vue&type=script&lang=js"
export * from "./ShotsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports